import { KuikaListTableStatusCellProps } from "../../../ui-kit/kuika-list-table/kuika-list-table";

export interface IDomainStatusPresentation {
  label: string;
  color: KuikaListTableStatusCellProps["color"];
  /** Rank for a status sort: live domains first, broken ones last. */
  sortOrder: number;
}

/**
 * How a domain's status reads on the domains list and on a domain's own page. The backend
 * status is free text: a value added there later still renders, as a grey badge carrying its
 * own name, and sorts after the states known here.
 */
export const getDomainStatusPresentation = (status: string | undefined): IDomainStatusPresentation => {
  const statusLower: string = (status ?? "").toLowerCase();
  if (statusLower === "active") return { label: "Active", color: "green", sortOrder: 0 };
  if (statusLower === "provisioning") return { label: "Provisioning", color: "orange", sortOrder: 1 };
  if (statusLower === "pending") return { label: "Pending", color: "orange", sortOrder: 2 };
  if (statusLower === "failed") return { label: "Failed", color: "red", sortOrder: 3 };
  return { label: status || "Unknown", color: "grey", sortOrder: 4 };
};
